<template>
  <main about>
    <section>
      <div class="split-wrap">
        <h3>creative-first to <br>unlock your potential</h3>
        <dl>
          <dt>크리에이티브를 기반으로 한 문제 해결</dt>
          <dd>
            뉴타입 이미지웍스는 2008년 2월, 서울에 설립된 크리에이티브 컨설턴시로, 크리에이티브를 우선으로 한 새로운 접근과 방법론을 통해 복잡한 문제들을 새로운 가치로 만듭니다.
            <br><br>
            Red Dot Awards, iF design awards, IDEA Awards, German Design Awards 등 다수의 글로벌 어워드 수상을 통해 크리에이티브 역량을 인정받고 있습니다.
            <ul class="awards">
              <li><img src="/img/common/award-red.png" alt="Red DotDesign Award"></li>
              <li><img src="/img/common/award-if.png" alt="IF Design Award"></li>
              <li><img src="/img/common/award-idea.png" alt="IDEA Award"></li>
              <li>
                <img src="/img/common/award-german.png" alt="German Design Award" class="hidden-ml-down">
                <img src="/img/common/award-german.m.png" alt="German Design Award" class="hidden-tp-up">
              </li>
            </ul>
          </dd>
        </dl>
      </div>
      <ul class="numbers">
        <li>
          <p><span>15</span> <sub>Years</sub></p>
          <p>years of experience</p>
        </li>
        <li>
          <p><span>300</span> <sub class="plus">+</sub></p>
          <p>projects complete</p>
        </li>
        <li>
          <p><span>40</span> <sub>People</sub></p>
          <p>Creative Professionals</p>
        </li>
        <li>
          <p><span>20</span> <sub class="plus">+</sub></p>
          <p>Awards</p>
        </li>
      </ul>
    </section>
    <section>
      <div class="split-wrap">
        <div>
          <h3>creative challengers for <br>unlimited boundaries</h3>
          <dl>
            <dt>경계를 넘나드는 창의적 사고</dt>
            <dd>뉴타입은 브랜딩, 디지털, 소셜 미디어, 영상, 전시 및 퍼블리싱 등 다양한 분야의 경계를 넘나드는 최고 수준의 크리에이티브 서비스를 제공합니다.</dd>
          </dl>
        </div>
        <div class="video">
          <video autoplay loop muted playsinline poster="/img/about/nt-gtoup-video-poster.png">
            <source src="/img/about/nt-gtoup-video.mp4" type="video/mp4">
          </video>
        </div>
      </div>
      <ul class="feature">
        <li>
          <dl>
            <dt>branding</dt>
            <dd>brand strategy consulting <br>corporate / brand identity design</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>digital media</dt>
            <dd>UX research / prototype design <br>digital platform planning / design / dev</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>exhibition/space</dt>
            <dd>exhibition identity / signage design <br>exhibition contents planning / design / dev</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>film/video</dt>
            <dd>film / video production & design <br>motion graphic design</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>social media</dt>
            <dd>social media strategy consulting <br>social media campaign / promotion</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>printed material</dt>
            <dd>printed material strategy consulting <br>printed material planning / design / publishing</dd>
          </dl>
        </li>
      </ul>
    </section>
    <section>
      <div class="split-wrap">
        <h3>creative solutions to <br>deliver genuine difference</h3>
        <dl>
          <dt>세계적인 수준의 크리에이티브 솔루션</dt>
          <dd>뉴타입은 다수의 글로벌 기업들과 수준 높은 경험들을 통해 끊임없이 진화하는 크리에이티브 솔루션을 만들고 있습니다.</dd>
        </dl>
      </div>
      <ul class="partners">
        <li><img src="/img/about/samsung.png" alt=""></li>
        <li><img src="/img/about/meta.png" alt=""></li>
        <li><img src="/img/about/naver.png" alt=""></li>
        <li><img src="/img/about/lg.png" alt=""></li>
        <li><img src="/img/about/cheil.png" alt=""></li>
        <li><img src="/img/about/nc.png" alt=""></li>
        <li><img src="/img/about/hyundai.png" alt=""></li>
        <li><img src="/img/about/visa.png" alt=""></li>
        <li><img src="/img/about/samoo.png" alt=""></li>
        <li><img src="/img/about/sk.png" alt=""></li>
      </ul>
    </section>
  </main>
</template>

<script>

export default {
  name: 'about',
  components: {},
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
    this.$store.commit('theme', 'default');
  },
};
</script>

<style lang="less">
@import "~@/less/proj.less";

[about] { .pt(60); .space-m; .fs(16,28,-0.25);
  h3 { .fs(24,28); .mb(30); .regular; }
  dt { .bold; }
  dd { .c(#666); }
  section { .mt(90); .pt(30); .-t(#e0e0e0);
    &:first-of-type { .mt(0); .-t; }
    .awards { .mt(20); .flex; justify-content: space-between;
      li {
        img { .block; .h(42); }
      }
    }
    .numbers { .mt(140); .grid(2);
      li {
        sub { .fs(16,24); vertical-align: top; &.plus { .fs(20,24); }}
        p { .fs(52,57); .bold; }
        p + p { .mt(10); .fs(14,21); .regular; }
      }
      li:nth-child(n+3) { .mt(50); }
    }
    .video { .mt(80);
      video { .ib; .wf; }
    }
    .feature { .mt(60);
      li:nth-child(n + 2) { .mt(35); }
      dt { .fs(20,29); .medium; }
      dd { .mt(10); .fs(16,22); .c(#333); }
    }
    .partners { .mt(60); .grid(2,8);
      img { .block; .max-w(100%); }
    }
  }
}

@media (min-width: @screen-tp-min) {
  [about] {
    section { .mt(60);
      .split-wrap { .grid(2); }
      .numbers { .mt(120); .flex; justify-content: space-between;
        li:nth-child(n+3) { .mt(0); }
      }
      .video { .mt(0); .tr;
        video { .w(70%); }
      }
      .feature { .mt(30); .grid(2);
        li:nth-child(2) { .mt(0); }
        li:nth-child(n+3) { .mt(35); }
      }
      .partners { .grid(5,47); grid-row-gap: 8px; }
    }
  }
}
@media (min-width: @screen-tl-min) {
  [about] { .pt(100);
    section { .pt(40);
      .feature { .mt(0); .grid(3);
        li:nth-child(n) { .mt(40); }
      }
    }
  }
}
@media (min-width: @screen-dm-min) {
  [about] { .pt(100); .space-d; .fs(18,28,-0.25);
    section { .mt(100); .pt(70);
      .split-wrap > div { h3 + dl { .mt(60); }}
      h3 { .fs(48,60); }
      .awards { .mt(35);
        li {
          img { .h(64); }
        }
      }
      .numbers { .mt(200);
        li {
          sub { .fs(20,24); &.plus { .fs(24,24); }}
          p { .fs(68,70); }
          p + p { .fs(18,26); }
        }
      }
      .feature {
        li:nth-child(n) { .mt(60); }
        dt { .fs(38,56); }
        dd { .fs(18,24); }
      }
      .partners { .grid(5,90); grid-row-gap: 10px; }
    }
  }
}
@media (min-width: @screen-dx-min) {
  [about] { .fs(20,32,-0.25);
    section { .mt(120); .pt(80);
      h3 { .fs(56,64); }
      .numbers { .mt(260);
        li {
          sub { .fs(24,24); &.plus { .fs(30,24); }}
          p { .fs(96,100); }
          p + p { .fs(20,26); }
        }
      }
      .feature {
        li:nth-child(n) { .mt(60); }
        dt { .fs(38,56); }
        dd { .fs(18,24); }
      }
      .partners { .grid(5,90); grid-row-gap: 10px; }
    }
  }
}
</style>
